import StorageWithEvents from './storageWithEvents';
import { arrayify } from './util';
var registerInstance = function (app, driver, prefix) {
    var instance = new StorageWithEvents(prefix, driver);
    var apiName = '$' + String(driver) + 'Storage';
    app.config.globalProperties[apiName] = instance;
    app.provide(apiName, instance);
};
var VueWebStoragePlugin = function (app, options) {
    if (options === void 0) { options = {}; }
    var safeOptions = Object.assign({}, {
        prefix: 'app_',
        drivers: 'local'
    }, options);
    arrayify(safeOptions.drivers).map(function (driver) {
        registerInstance(app, driver, safeOptions.prefix);
    });
};
export default VueWebStoragePlugin;
